import { render, staticRenderFns } from "./OrgDetailHeader.vue?vue&type=template&id=77064f74&scoped=true&"
import script from "./OrgDetailHeader.vue?vue&type=script&lang=ts&"
export * from "./OrgDetailHeader.vue?vue&type=script&lang=ts&"
import style0 from "./OrgDetailHeader.vue?vue&type=style&index=0&id=77064f74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77064f74",
  null
  
)

export default component.exports